'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var sort = exports.sort = 100;

var styles = exports.styles = function styles(_styles, props) {
	var bgImage = {};

	if (props.backgroundImage) {
		bgImage['background-image'] = 'url(' + props.backgroundImage + ')';
		bgImage['background-repeat'] = props.backgroundRepeat;
		bgImage['background-position'] = props.backgroundPosition;
		bgImage['background-size'] = props.backgroundSize;
	}

	return _extends({}, _styles, bgImage, {
		'background-color': props.backgroundColor
	});
};

var config = exports.config = function config() {
	return {
		label: 'Background',
		props: [{
			name: 'backgroundColor',
			inputType: 'color',
			label: 'Background color',
			default: ''
		}, {
			name: 'backgroundImage',
			inputType: 'media',
			label: 'Background image',
			default: ''
		}, {
			name: 'backgroundRepeat',
			inputType: 'select',
			label: 'Background repeat',
			default: 'initial',
			values: ['initial', 'inherit', 'no-repeat', 'repeat', 'repeat-x', 'repeat-y']
		}, {
			name: 'backgroundPosition',
			inputType: 'select',
			label: 'Background position',
			default: 'initial',
			values: ['initial', 'inherit', 'left top', 'left center', 'left bottom', 'right top', 'right center', 'right bottom', 'center top', 'center center', 'center bottom']
		}, {
			name: 'backgroundSize',
			inputType: 'select',
			label: 'Background size',
			default: 'initial',
			values: ['initial', 'inherit', 'auto', 'cover', 'contain']
		}]
	};
};